export default {
  getGroups: (state) => state.groups,
  getGroup: (state) => (id) => state.groups.find((group) => group.id === id),
  getLinks: (state) => state.links,
  getUsers: (state) => state.users,
};
